var render = function render() {
  var _vm$contactWay;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "all-container flex",
    class: {
      closeSide: !_vm.open,
      horizontal: _vm.horizontal
    }
  }, [!_vm.horizontal ? _c("side-bar", {
    staticClass: "aside-container",
    attrs: {
      collapsed: _vm.open
    }
  }) : _vm._e(), _c("div", {
    staticClass: "main-container",
    class: {
      hasTag: _vm.tagShow
    }
  }, [_c("div", {
    class: {
      "fixed-header": _vm.fixHeader
    }
  }, [!_vm.horizontal ? _c("nav-bar", {
    attrs: {
      collapsed: _vm.open
    }
  }) : _c("div", {
    staticClass: "horizontal-nav flex"
  }, [_c("horizontal-side"), _c("nav-bar", {
    staticClass: "nav-user",
    attrs: {
      horizontal: _vm.horizontal
    }
  })], 1), _vm.tagShow ? _c("tag-view") : _vm._e()], 1), _c("div", {
    staticClass: "app-main",
    attrs: {
      id: "app-main"
    }
  }, [_c("router-view", {
    key: _vm.key
  }), _c("back-top")], 1), _vm.accountInfo.customerId > 0 && (_vm$contactWay = _vm.contactWay) !== null && _vm$contactWay !== void 0 && _vm$contactWay.icon ? _c("div", {
    staticClass: "contactBox"
  }, [_c("img", {
    attrs: {
      src: _vm.contactWay.icon,
      alt: "icon"
    }
  }), _c("div", {
    staticClass: "hoverContBox"
  }, [_c("div", {
    staticClass: "hoverContent",
    domProps: {
      innerHTML: _vm._s(_vm.contactWay.copyWriting)
    }
  })])]) : _vm._e(), _c("message"), _c("force-readering-message-model"), _c("noticeUploadInsuranceTemplate")], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };